<template>
  <div class="article-page">
    <div class="article-view">
      <div>
        <h2
          class="title"
          align="center"
        >{{ article.Title }}</h2>
        <h4
          v-if="article.SubTitle"
          class="subtitle"
          align="center"
        >{{ article.SubTitle }}</h4>
        <hr>
        <div
          class="artical-content scroll-container"
          style=""
        >
          <div
            class="content"
            v-html="article.MainContent"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as service from '@/service/httpService'
import { mapState } from 'vuex'

export default {
  name: 'ArticleView',
  data () {
    return {
      article: {},
      recommendList: []
    }
  },
  computed: {
    ...mapState({
      comeFromOldSystem: 'comeFromOldSystem'
    }),
    getId () {
      return this.$route.params.id
    }
  },
  created () {
    this.getArticle()
  },
  methods: {
    getArticle () {
      let url = window.dataUrl.History.article.replace('{id}', this.getId)
      service.historyEventService.loadColums(url).then(res => {
        this.article = res.data
        document.title = this.article.Title
        let content = this.article.MainContent
        content = content.replace(/<br\/>/g, '</p><br/><p>')
        content = content.replace(/<\/p><p>/g, '</p><br/><p>')
        this.article.MainContent = content
      })
      let recommendUrl = window.dataUrl.History.recommend.replace('{id}', this.getId)
      service.historyEventService.loadRecommend(recommendUrl).then(res => {
        let data = res.data
        // 26
        data.forEach(e => {
          if (e.Title.length > 26) {
            e.littleTitle = e.Title
            e.Title = e.littleTitle.substr(0, 25) + '...'
          } else {
            e.littleTitle = e.Title
          }
        })
        this.recommendList = [[], []]
        for (let i = 0; i < data.length; i++) {
          if (i % 2 === 0) {
            this.recommendList[0].push(data[i])
          } else {
            this.recommendList[1].push(data[i])
          }
        }
        // this.recommendList = res.data
      })
    },
    showPublish (item) {
      return window.moment(item.PublishTime).format('YYYY-MM-DD')
    },
    downAttachment (storeId) {
      service.FileManageV2.download(storeId)
    },
    checkAttachment (OnlineViewUrl) {
      window.open(OnlineViewUrl)
    },
    turnToDetail (id) {
      const { href } = this.$router.resolve({
        path: '/article/' + id
      })
      window.open(href)
    }
  }
}
</script>


<style lang="scss">
.article-page {
  // position: absolute;
  // top: 65px;
  // bottom: 0;
  width: 100%;
  overflow-y: auto;

  strong {
    font-weight: bold;
  }
  em {
    font-style: italic;
  }
  ol {
    list-style: decimal;
  }
  ul {
    list-style: disc;
  }
  .article-view {
    width: 1000px;
    margin: 30px auto 50px;
    line-height: 30px;
    .title {
      font-size: 24px;
    }
    .subtitle {
      margin: 5px;
      font-size: 20px;
    }
    img {
      display: block;
      margin: 0 auto;
      max-width: 80%;
    }
  }
  .recommend-title {
    font-size: 18px;
    font-weight: bold;
  }
  .content {
    text-indent: 2em;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/common/about-us.vue